// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import api from '../../../common/api';
import config from '../../../share/config';
import handler from '../../../share/util/apiResultValidator';
import cstmTable from '../../../share/components/vue/PaginationTable';
import resource from '../../../share/util/resourceMap';
import util from '../../../share/util/utils';
import loading from '../../../share/components/vue/ProcessingIcon';
import treeView from "../../../share/components/vue/TreeView";
import memoModal from '../../vue/MemoPage';
import ffdModal from '../../vue/FFDModal';
import bmdModal from '../../vue/BMDModal';
import detailFdModal from '../../vue/DetailFDModal';
import diagnoseResource from '../../../share/util/diagnose';
import logWrapper from '../../../share/logWrapper';
import allDtcPage from '../../vue/AllDtcPage';
import dtcPage from '../../vue/DtcPage';
import obdDtcPage from '../../vue/ObdDtcPage';
import obdAllDtcPage from '../../vue/ObdAllDtcPage';
import obdPermanentDtcPage from '../../vue/ObdPermanentDtcPage';
import obdOnboardMonitorTestPage from '../../vue/ObdOnboardMonitorTestPage';
import obdVehicleInfoPage from '../../vue/obdVehicleInfoPage';
import obdDataMonitorPage from '../../vue/ObdDataMonitorPage';
import obdIumprPage from '../../vue/ObdIumprPage';
import obdReadinessStatusPage from '../../vue/ObdReadinessStatusPage';
import readinessCodePaging from '../../vue/ReadinessCodePage';
import vehicleControlHistoryPaging from '../../vue/VehicleControlHistoryPage';
import customizePage from '../../vue/CustomizePage';
import allCustomizePage from '../../vue/AllCustomizePage';
import cancelCodePage from '../../vue/CancelCodePage';
import workSupportPage from '../../vue/WorkSupportPage';
import workSupportPage146 from '../../vue/WorkSupportPage146';
import workSupportPageReq05 from '../../vue/WorkSupportPageReq05';
import dataMonitorPage from '../../vue/DataMonitorPage';
import multipleDataMonitorPage from '../../vue/MultipleDataMonitorPage';
import svgIcon from '../../../share/components/vue/SVGIcon';
import apiService from '../../../share/util/api/service';
import ApiService from '../../../share/util/api/service';
import { getSystemNameIsSpecial } from '../../../share/util/resourceMap';
import dmUtil from "../../pages/dataMonitor/dataMonitorUtil";
import { getCsvFileName } from '../../../util/fileExport';
import alert from '../../../share/alert';

const DIAG_SYSTEM = 'diagSytem.';
const HEADER_COLUMN_CSV = ["status", "description"];

export default {
  name: "dataRecollection",
  data() {
    return {
      processing: false,
      projectId: null,
      measuredId: null,
      treeData: {},
      isTreeViewOpen: true,
      isDomestic: false,
      measuredDataColumns: [],
      measuredDataItems: [],
      ffdTable: [],
      ffdTitle: '',
      ffdSystem: '',
      ffdDescription: '',
      isReq05: false,
      storedDataNumber: '-',
      bmdTable: [],
      bmdDescription: '',
      bmdSystem: '',
      detailFdTable: [],
      fdTitle: '', // 詳細FD画面タイトル
      status: '', // 詳細FDステータス
      selectedSystem: null,
      testModeVisible: false,
      isActive: JSON.parse(this.isActiveLabel),
      navItemLabel: "",
      obdFuncItemLabel: "",
      ecuName: this.systemName.replace(DIAG_SYSTEM, ""),
      itemName: this.itemNameProp,
      obdDataId: this.obdDataIdProp,
      obdSystems: JSON.parse(this.obdSystemsProp),
      dataPlayback: true, //FFDモーダルのエクスポートボタン表示用
      destinationAPI: null, // 各機能(ALLDTC,DTC等の一覧取得処理でインスタンス変数を定義せず使用していた為、devToolで警告が出ていた。(この変数はメモ画面開く際に必要になります))
      displayEcuName: '', // 画面表示用のECU名
      displayItemName: '', //画面表示等の項目名
      modalMemo: false,
      modalFfd: false,
      modalBmd: false,
      modalDetailFd: false,
      isMemoDialogLoading: false,
      isDetailFdModalLoading: false,
      shouldShowBackButton: true, // 「戻る」ボタン表示フラグ
      isSpecial: false,
      isOnlyExport: JSON.parse(this.isOnlyCsvExport),
      selectImmutableId: null // 選択している不変IDを保持する
    };
  },

  watch: {
    language() { // eslint-disable-line no-unused-vars
      // ツリーデータ初期化
      this.treeData = {};
      this.$nextTick(() => {
        this.setupTreeView();
      });
    },
  },

  components: {
    'data-tree': treeView,
    'processing-view': loading,
    'cstm-table': cstmTable,
    'memo-modal': memoModal,
    'ffd-modal': ffdModal,
    'bmd-modal': bmdModal,
    'detail-fd-modal': detailFdModal,
    'allDtc-paging': allDtcPage,
    'dtc-paging': dtcPage,
    'obdDtc-paging': obdDtcPage,
    'obdAllDtc-paging': obdAllDtcPage,
    'obdPermanent-paging': obdPermanentDtcPage,
    'obdOnboardMonitorTestPage-paging': obdOnboardMonitorTestPage,
    'obdVehicleInfotPage-paging': obdVehicleInfoPage,
    'obdDataMonitor-paging': obdDataMonitorPage,
    'obdIumpr-paging': obdIumprPage,
    'obdReadinessStatus-paging': obdReadinessStatusPage,
    'readinessCode-paging': readinessCodePaging,
    'vehicleControlHistory-paging': vehicleControlHistoryPaging,
    'customize-paging': customizePage,
    'cancelCode-paging': cancelCodePage,
    'workSupport-paging': workSupportPage,
    'workSupport146-paging': workSupportPage146,
    'workSupportReq05-paging': workSupportPageReq05,
    'dataMonitor-paging': dataMonitorPage,
    'multiple-dataMonitor-paging': multipleDataMonitorPage,
    'all-customize-paging': allCustomizePage,
    'svg-icon': svgIcon
  },

  // router prames 対応
  props: [
    "measuredIdProp",
    "allMeasuresData",
    "isActiveLabel",
    "systemName",
    "systemIds",
    "itemNameProp",
    "obdDataIdProp",
    "obdSystemsProp",
    "isOnlyCsvExport",
    "updateExportPercentage"
  ],

  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('cache', ['cacheActiveDataId', 'cacheFFDStores', 'cacheBmdStores', 'cacheDetailFdStores', 'cacheProjectDetails', 'cacheDiagProjectList']),

    /** 初期セットアップツリー表示作成 */
    setupTreeView: async function () {
      // プロジェクト詳細画面からのパラメータからデータ取得
      const allMeasuresData = await JSON.parse(this.allMeasuresData)[0];
      const allDtcTreeList = this.changeDisplayData(allMeasuresData.repro);
      const vchTreeList = this.changeDisplayData(allMeasuresData.vch);
      const cstTreeList = this.changeDisplayData(allMeasuresData.cst);
      const cncTreeList = this.changeDisplayData(allMeasuresData.cnc);
      const wspTreeList = this.changeDisplayData(allMeasuresData.wsp);
      const dmatTreeList = this.changeDisplayData(allMeasuresData.dmat);
      const obdTreeList = this.changeDisplayData(allMeasuresData.obd);

      // 現在選択されているECU名を引数に渡すことによって、言語変更時に機能名の配下にECUが複数あった場合に開いた状態を防ぐ
      const projectNodes = this.createNodes(allDtcTreeList, vchTreeList, cstTreeList, cncTreeList, wspTreeList, dmatTreeList, obdTreeList);
      this.treeData = {
        // 初期表示でツリーを展開するため、先頭のヘッダーは情報設定しない(非表示)。
        name: 'nop',
        children: [
          {
            name: this.projectId,
            selectId: util.getUniqueIdStr(),
            isSelected: false,
            noSelected: true,
            isOpen: true,
            children: projectNodes
          },
        ]
      };

      const itemKey = Object.keys(this.isActive).find(key => { return this.isActive[key]; });
      this.navItemLabel = this.setNavItem(itemKey);
      // OBD機能の場合機能名の後ろに専用ラベルを設定
      if (itemKey.substring(0, 3) === "obd") {
        this.obdFuncItemLabel = "fixed_resource.obd_menu";
      } else {
        this.obdFuncItemLabel = "";
      }

      // 特殊機能フラグ
      let target = null;
      let funcName = "";
      switch (itemKey) {
        case 'diagCode': {
          target = allDtcTreeList.find((t) => t.measuredId === this.measuredId);
          funcName = 'individualDtc';
          break;
        }
        case 'controlHistory': {
          target = vchTreeList.find((t) => t.measuredId === this.measuredId);
          funcName = 'controlHistory';
          break;
        }
        case 'cancelCode': {
          target = cncTreeList.find((t) => t.measuredId === this.measuredId);
          funcName = 'cancelCode';
          break;
        }
        case 'workSupport': {
          target = wspTreeList.find((t) => t.measuredId === this.measuredId);
          funcName = 'workSupport';
          break;
        }
      }

      // 計測データ一覧を表示する
      this.createSaveDataList(
        this.projectId,
        this.measuredId,
        this.ecuName.replace(DIAG_SYSTEM, ""),
        this.itemName,
        this.obdDataId,
        this.obdSystems,
        funcName,
        target ? target.isSpecial : false
      ); //ECU名に「diagsystem.」の有無にかかわらずリプレイスを行う
    },

    /**
     * ツリー表示用にobjectの中を成形
     * @param {Array} res 計測データ（レスポンス）
     * @returns 表示用ツリーデータ
     */
    changeDisplayData(res) {
      const retChangeObj = [];
      const resReversed = util.sortItems(res.reverse(), 'registered_at');
      for (const d of resReversed) {
        retChangeObj.push({
          projectId: this.projectId,
          measuredId: String(d.registered_at),
          registered_at: d.registered_at,
          // マルチデータモニタはシステム名を翻訳し'/'で連結
          systems: (d.function_name !== 'multiple_dm') ? d.system : d.systemIds.map(id => {
            return `${this.$t('diagSytem.' + id)} (${dmUtil.getAbbrSysName(id)})`;
          }).join('/'),
          itemName: d.item_name ? d.item_name : undefined,
          name: d.name,
          function_name: d.function_name,
          selectId: util.getUniqueIdStr(),
          isOpen: false,
          isSelected: this.measuredId === String(d.registered_at),
          special_requirement_id: d.special_requirement_id ? d.special_requirement_id : undefined,
          obdDataId: d.obdDataId || undefined,
          obdSystems: d.obdSystems || undefined,
          isSpecial: d.isSpecial || false,
        });
      }
      return retChangeObj;
    },

    /**
     * ツリーデータ作成
     * @param {Array} allDtc プロジェクト詳細全DTC、DTC、レディネスコード
     * @param {Array} vch プロジェクト詳細制御作動履歴データ
     * @param {Array} cst プロジェクト詳細カスタマイズデータ
     * @param {Array} cnc プロジェクト詳細キャンセルコードデータ
     * @param {Array} wsp プロジェクト詳細作業サポートデータ
     * @param {Array} dmat プロジェクト詳細データモニタ、アクティブテスト
     * @param {Array} obd プロジェクト詳細OBD
     */
    /* eslint-disable max-statements */
    createNodes(allDtc, vch, cst, cnc, wsp, dmat, obd) {
      const retNods = [];
      for (const [key, value] of Object.entries(this.isActive)) {
        const node = {
          selectId: util.getUniqueIdStr(),
          isSelected: false,
          noSelected: true,
          isOpen: value,
        };

        let groupData = null;
        if (key === 'allDtc') {
          node.name = this.$t(`message.label_measured_data_details_all_dtc`);
          node.children = allDtc.filter(data => { return data.function_name === 'alldtc'; });
          node.displaySort = 1;
        }
        if (key === 'diagCode') {
          node.name = this.$t(`individual.individual_diagnosis_function_diag_code`);
          groupData = util.groupBy(allDtc.filter(data => { return data.function_name === "individualDtc"; }), 'systems');
          node.children = this.createChildEcuData(groupData, value, ApiService.DIAG);
          node.displaySort = 2;
        }
        if (key === 'readiness') {
          node.name = this.$t(`individual.label_readiness_code`);
          groupData = util.groupBy(allDtc.filter(data => { return data.function_name === "readinessCode"; }), 'systems');
          node.children = this.createChildEcuData(groupData, value, ApiService.DIAG);
          node.displaySort = 3;
        }
        if (key === 'controlHistory') {
          node.name = this.$t(`individual.individual_diagnosis_function_vehicle_control_history`);
          groupData = util.groupBy(vch, 'systems');
          node.children = this.createChildEcuData(groupData, value, ApiService.VCH);
          node.displaySort = 4;
        }
        if (key === 'allCustomize') {
          node.name = this.$t(`message.label_menu_all_customize`);
          groupData = util.groupBy(cst.filter(data => { return data.function_name === "all_cst"; }), 'systems');
          node.children = this.createChildEcuData(groupData, value, ApiService.CST);
          node.displaySort = 5;
        }
        if (key === 'customize') {
          node.name = this.$t(`individual.individual_diagnosis_function_customize`);
          groupData = util.groupBy(cst.filter(data => { return data.function_name === "cst"; }), 'systems');
          node.children = this.createChildEcuData(groupData, value, ApiService.CST);
          node.displaySort = 6;
        }
        if (key === 'cancelCode') {
          node.name = this.$t(`individual.individual_diagnosis_function_cancel_code`);
          groupData = util.groupBy(cnc, 'systems');
          node.children = this.createChildEcuData(groupData, value, ApiService.CNC);
          node.displaySort = 7;
        }
        if (key === 'workSupport') {
          node.name = this.$t(`individual.individual_diagnosis_function_work_support`);
          groupData = util.groupBy(wsp, 'systems');
          node.children = this.createChildEcuData(groupData, value, ApiService.WSP);
          node.displaySort = 8;
        }
        if (key === 'dataMonitor') {
          node.name = this.$t(`individual.individual_diagnosis_function_data_monitor`);
          groupData = util.groupBy(dmat.filter(data => { return data.function_name === "dm"; }), 'systems');
          node.children = this.createChildEcuData(groupData, value, ApiService.DMAT);
          node.displaySort = 9;
        }
        if (key === 'multipleDataMonitor') {
          node.name = this.$t(`message.label_menu_multi_data_monitor`);
          groupData = util.groupBy(dmat.filter(data => { return data.function_name === "multiple_dm"; }), 'systems');
          node.children = this.createChildEcuData(groupData, value, ApiService.DMAT);
          node.displaySort = 10;
        }
        if (key === 'activeTest') {
          node.name = this.$t(`individual.individual_diagnosis_function_active_test`);
          groupData = util.groupBy(dmat.filter(data => { return data.function_name === "at"; }), 'systems');
          node.children = this.createChildEcuData(groupData, value, ApiService.DMAT);
          node.displaySort = 11;
        }

        this.createObdNode(key, node, obd, value);

        retNods.push(node);
      }
      return util.sortItems(retNods, 'displaySort', 'asc');
    },
    /* eslint-enable max-statements */

    /**
     * OBD用ツリーノードの作成
     *
     * @param {string} key キー名称
     * @param {object} node ノード情報
     * @param {object} obd プロジェクト詳細OBD
     * @param {Boolean} value 機能名のフラグ
     */
    createObdNode(key, node, obd, value) {
      let groupData = null;

      if (key === 'obdAllDtc') {
        node.name = `${this.$t("fixed_resource.obd_menu_alldtc")}${this.$t("fixed_resource.obd_menu")}`;
        node.children = obd.filter(data => { return data.function_name === "all_dtc"; });
        node.displaySort = 12;
      }
      if (key === 'obdDiagCode') {
        node.name = `${this.$t("fixed_resource.obd_menu_dtc")}${this.$t("fixed_resource.obd_menu")}`;
        groupData = util.groupBy(obd.filter(data => { return data.function_name === "individual_dtc"; }), 'systems');
        node.children = this.createChildEcuData(groupData, value, ApiService.OBD);
        node.displaySort = 13;
      }
      if (key === 'obdPermanentDiagCode') {
        node.name = `${this.$t("fixed_resource.obd_menu_pdtc")}${this.$t("fixed_resource.obd_menu")}`;
        groupData = util.groupBy(obd.filter(data => { return data.function_name === "p_dtc"; }), 'systems');
        node.children = this.createChildEcuData(groupData, value, ApiService.OBD);
        node.displaySort = 14;
      }
      if (key === 'obdVehicleInfo') {
        node.name = `${this.$t("fixed_resource.obd_menu_infotype")}${this.$t("fixed_resource.obd_menu")}`;
        groupData = util.groupBy(obd.filter(data => { return data.function_name === "obd_vehicle_info"; }), 'systems');
        node.children = this.createChildEcuData(groupData, value, ApiService.OBD);
        node.displaySort = 15;
      }
      if (key === 'obdOnBoardMonitorTest') {
        node.name = `${this.$t("fixed_resource.obd_menu_monitortest")}${this.$t("fixed_resource.obd_menu")}`;
        groupData = util.groupBy(obd.filter(data => { return data.function_name === "onboard_monitor_test"; }), 'systems');
        node.children = this.createChildEcuData(groupData, value, ApiService.OBD);
        node.displaySort = 16;
      }
      if (key === 'obdDataMonitor') {
        node.name = `${this.$t("fixed_resource.obd_menu_datamonitor")}${this.$t("fixed_resource.obd_menu")}`;
        groupData = util.groupBy(obd.filter(data => { return data.function_name === "data_monitor"; }), 'systems');
        node.children = this.createChildEcuData(groupData, value, ApiService.OBD);
        node.displaySort = 17;
      }
      if (key === 'obdIumpr') {
        node.name = `${this.$t("fixed_resource.obd_menu_jumpr")}${this.$t("fixed_resource.obd_menu")}`;
        groupData = util.groupBy(obd.filter(data => { return data.function_name === "individual_iumpr"; }), 'systems');
        node.children = this.createChildEcuData(groupData, value, ApiService.OBD);
        node.displaySort = 18;
      }
      if (key === 'obdReadinessStatus') {
        node.name = `${this.$t("fixed_resource.obd_menu_readiness_status")}${this.$t("fixed_resource.obd_menu")}`;
        groupData = util.groupBy(obd.filter(data => { return data.function_name === "individual_readiness"; }), 'systems');
        node.children = this.createChildEcuData(groupData, value, ApiService.OBD);
        node.displaySort = 19;
      }
    },

    /**
     * ECU名配下のツリーデータ作成
     * @param {Object} measuredDataObj グルーピングされた計測データオブジェクト
     * @param {Boolean} treeOpen 機能名のフラグ
     * @param {string} serviceType Backend サービス
     * @returns ECU名配下のツリーデータ
     */
    createChildEcuData(measuredDataObj, treeOpen, serviceType) {
      const retList = [];
      // ECU名作成
      Object.keys(measuredDataObj).map(ecuKey => {
        const obj = new Object();
        obj.isSelected = false;
        obj.noSelected = true;
        if (serviceType === ApiService.OBD) {
          // OBD の場合は翻訳しない
          obj.name = ecuKey;
          obj.isOpen = !!(this.ecuName === ecuKey && treeOpen);
        } else {
          obj.name = this.$te(ecuKey) ? this.$t(ecuKey) : ecuKey;
          // 選択されているECU名と計測データオブジェクトのECU名(e.g. EGI,CGW)と選択されている機能名を比較
          obj.isOpen = this.ecuName ? (this.ecuName.replace(DIAG_SYSTEM, "") === ecuKey.replace(DIAG_SYSTEM, "") && treeOpen) : false; // 同じECU名があった場合ほかのプロジェクト部分のツリーが開く
        }
        // itemNameがある機能は項目名を追加する
        if (measuredDataObj[ecuKey][0].itemName) {
          obj.children = this.createChildItemName(measuredDataObj[ecuKey], treeOpen);
        } else {
          obj.children = measuredDataObj[ecuKey];
        }
        retList.push(obj);
      });
      return retList;
    },

    /**
     * 項目名配下のツリーデータ作成
     * @param {Array} measuredDataList 計測データリスト
     * @param {Boolean} treeOpen 機能名のフラグ
     * @returns 項目名配下のツリーデータ
     */
    createChildItemName(measuredDataList, treeOpen) {
      const retList = [];
      const groupData = util.groupBy(measuredDataList, 'itemName');

      // 項目名作成
      Object.keys(groupData).map(itemKey => {
        const obj = new Object();
        obj.isSelected = false;
        obj.noSelected = true;
        obj.children = groupData[itemKey];
        obj.name = this.$t(itemKey);
        // 選択されている項目名と計測データオブジェクトの項目名と選択されている機能名を比較
        obj.isOpen = this.itemName ? (this.itemName === itemKey && treeOpen) : false; // 同じ項目名があった場合ほかのプロジェクト部分のツリーが開く;
        retList.push(obj);
      });

      return retList;
    },

    /**
     * 計測データ再生一覧作成
     * 子画面の各種ファイルの関数を呼び出す
     * @param {String} projectId プロジェクトID
     * @param {String} measuredId 計測データID
     * @param {String} selectEcuName ECU名
     * @param {String} obdDataId OBD Data ID
     * @param {Array<object>} obdSystems `systems` と `systemNo` と `diagnosticSystemId` を持つ配列
     * @param {string} funcName 選択中の機能名
     * @param {boolean} isSpecial 特殊機能フラグ
     */
    async createSaveDataList(
      projectId,
      measuredId,
      selectEcuName,
      itemName = undefined,
      obdDataId,
      obdSystems,
      funcName,
      isSpecial
    ) {
      try {
        // 表示データ作成時に「戻る」ボタン表示フラグを変更
        this.updateShouldShowBackButton();
        this.processing = true;

        if (obdDataId) {
          await this.createOBDSaveDataList(
            obdDataId,
            measuredId,
            selectEcuName,
            obdSystems
          );
          return;
        }

        // 画面表示用のECU名を設定
        this.displayEcuName = funcName === 'controlHistory' || funcName === 'cancelCode' || funcName === 'individualDtc' ? getSystemNameIsSpecial(this, funcName, selectEcuName, isSpecial) : DIAG_SYSTEM + selectEcuName;
        this.ecuName = DIAG_SYSTEM + selectEcuName;

        // データモニタの再生データは非同期で取得するため、取得中であれば停止する
        await this.$refs.data_monitor.stopFetchingMeasurement();

        // 機能ごとに処理が異なる為
        if (this.isActive['allDtc']) {
          await this.$refs.all_dtc.createAllDtcMeasuresList(projectId, measuredId);
          this.destinationAPI = config.DIAG;
        }
        if (this.isActive['diagCode']) {
          await this.$refs.diag_code.createDtcMeasuresList(projectId, measuredId, selectEcuName);
          this.destinationAPI = config.DIAG;
        }
        if (this.isActive['readiness']) {
          await this.$refs.readiness_code.createReadinessCodeMeasuresList(projectId, measuredId, selectEcuName);
          this.destinationAPI = config.DIAG;
        }
        if (this.isActive['controlHistory']) {
          await this.$refs.vehicle_control_history.createVehicleControlHistoryMeasuresList(projectId, measuredId);
          this.destinationAPI = config.VCH;
        }
        if (this.isActive['customize']) {
          await this.$refs.customize.createCstMeasuresList(projectId, measuredId, selectEcuName);
          this.destinationAPI = config.CST;
        }
        if (this.isActive['cancelCode']) {
          await this.$refs.cancel_code.createCncMeasuresList(projectId, measuredId, selectEcuName, isSpecial);
          this.destinationAPI = config.CNC;
        }
        if (this.isActive['workSupport']) {
          await this.createWspMeasuresList(itemName, projectId, measuredId, selectEcuName, isSpecial);
        }
        if (this.isActive['dataMonitor'] || this.isActive['activeTest']) {
          const dmatMeasuresData = await JSON.parse(this.allMeasuresData)[0].dmat;
          const selectedMeasureData = dmatMeasuresData.find(
            measureData => String(measureData.registered_at) === this.measuredId
          );
          this.isSpecial = selectedMeasureData.isSpecial || false;
          // 取得完了を待たない
          this.$refs.data_monitor.createDmtMeasuresList(selectedMeasureData, selectEcuName);
          this.destinationAPI = config.DMAT;
        }
        if (this.isActive['multipleDataMonitor']) {
          this.displayEcuName = this.displayEcuName.replace(DIAG_SYSTEM, "");

          const dmatMeasuresData = await JSON.parse(this.allMeasuresData)[0].dmat;
          const selectedMeasureData = dmatMeasuresData.find(
            measureData => String(measureData.registered_at) === this.measuredId
          );
          // 取得完了を待たない
          this.$refs.multiple_data_monitor.createDmtMeasuresList(selectedMeasureData, selectEcuName);
          this.destinationAPI = apiService.DMAT;
        }
        if (this.isActive['allCustomize']) {
          this.displayEcuName = this.$t('message.label_menu_all_system');
          await this.$refs.all_customize.createCstMeasuresList(projectId, measuredId);
          this.destinationAPI = apiService.CST;
        }
      } finally {
        this.processing = false;
      }
    },

    /**
     * 作業サポートの計測データ再生一覧作成
     * @param {String} itemName 項目名
     * @param {String} projectId プロジェクトID
     * @param {String} measuredId 計測データID
     * @param {String} selectEcuName ECU名
     * @param {Boolean} isSpecial 特殊機能フラグ
     */
    async createWspMeasuresList(itemName, projectId, measuredId, selectEcuName, isSpecial) {
      // 画面表示用の項目名を設定
      this.displayItemName = itemName;
      this.selectImmutableId = Number(itemName.split('.')[1]);
      // 不変IDで分岐させる
      switch (this.selectImmutableId) {
        case 14601:
          await this.$refs.work_support_146.createWorkSupport146MeasuresList(projectId, measuredId, selectEcuName, '146', this);
          break;
        case 5000501:
        case 6000501:
          await this.$refs.work_support_req05.createWorkSupportReq05MeasuresList(projectId, measuredId, this.selectImmutableId);
          break;
        default:
          await this.$refs.work_support.createWorkSupportMeasuresList(projectId, measuredId, selectEcuName, this.selectImmutableId, isSpecial);
          break;
      }
      this.destinationAPI = config.WSP;
      // work_support マウント後に再度「戻る」ボタンの表示確認
      this.updateShouldShowBackButton();
    },

    /**
     * OBD計測データ再生一覧作成
     * @param {String} obdDataId OBD Data ID
     * @param {String} measuredId 計測データID
     * @param {String} selectEcuName ECU名
     * @param {Array<object>} obdSystems `systems` と `systemNo` と `diagnosticSystemId` を持つ配列
     */
    async createOBDSaveDataList(
      obdDataId,
      measuredId,
      selectEcuName,
      obdSystems
    ) {
      // OBD機能の場合、ECU名は車両から取得したシステム名を使用
      this.ecuName = selectEcuName;
      this.displayEcuName = selectEcuName;

      if (this.isActive['obdAllDtc']) {
        await this.$refs.obd_all_dtc.createObdAllDtcMeasuresList(obdDataId, measuredId, obdSystems);
        this.destinationAPI = apiService.OBD;
      }
      if (this.isActive['obdDiagCode']) {
        await this.$refs.obd_dtc.createObdDiagCodeMeasuresList(obdDataId, measuredId, selectEcuName, obdSystems[0]?.systemNo);
        this.destinationAPI = apiService.OBD;
      }
      if (this.isActive['obdPermanentDiagCode']) {
        await this.$refs.obd_p_dtc.createObdPermanentDiagCodeMeasuresList(obdDataId, measuredId, selectEcuName, obdSystems[0]?.systemNo);
        this.destinationAPI = apiService.OBD;
      }
      if (this.isActive['obdVehicleInfo']) {
        await this.$refs.obd_vehicle_info.createObdVehicleInfoMeasuresList(obdDataId, measuredId, selectEcuName);
        this.destinationAPI = apiService.OBD;
      }
      if (this.isActive['obdOnBoardMonitorTest']) {
        await this.$refs.obd_monitor_test.createObdOnBoardMonitorTestMeasuresList(obdDataId, measuredId, selectEcuName, obdSystems[0]?.systemNo);
        this.destinationAPI = apiService.OBD;
      }
      if (this.isActive['obdDataMonitor']) {
        const obdMeasuresData = JSON.parse(this.allMeasuresData)[0].obd;
        const selectedMeasureData = obdMeasuresData.find(
          measureData => measureData.measure_id === measuredId
        );
        // 取得完了を待たない
        this.$refs.obd_data_monitor.createObdDataMonitorMeasuresList(selectedMeasureData, obdSystems[0]?.diagnosticSystemId);
        this.destinationAPI = apiService.OBD;
      }
      if (this.isActive['obdIumpr']) {
        await this.$refs.obd_iumpr.createObdIumprMeasuresList(obdDataId, measuredId, selectEcuName);
        this.destinationAPI = apiService.OBD;
      }
      if (this.isActive['obdReadinessStatus']) {
        await this.$refs.obd_readiness_status.createObdReadinessStatusMeasuresList(obdDataId, measuredId, selectEcuName);
        this.destinationAPI = apiService.OBD;
      }
    },

    /**
     * ツリービューから再生する計測データを切り替え
     * @param {Object} arg 選択されているツリー
     * @returns 同じ計測データを選択していた場合：なにもしない
     */
    selectMeasuredData: function (arg) {
      // ツリービューから同じ計測データ ID のノードが選択された場合は再取得しない
      if (arg.data.measuredId === this.measuredId) {
        if (arg.data.function_name === "multiple_dm") {
          // マルチDMで言語切り換えした際は、ツリービューに表示されているシステム名を設定する
          this.displayEcuName = arg.data.systems;
        }
        return;
      }
      this.treeData.children.forEach(e => { e.isSelected = arg.data.selectId === e.selectId; });
      this.measuredId = arg.data.measuredId;
      const systems = arg.data.systems ? arg.data.systems.replace(DIAG_SYSTEM, "") : "";
      const itemName = arg.data.itemName ? arg.data.itemName : undefined;
      this.itemName = itemName;
      const obdDataId = arg.data.obdDataId ? arg.data.obdDataId : undefined;
      this.obdDataId = obdDataId;
      const obdSystems = arg.data.obdSystems || undefined;
      this.obdSystems = obdSystems;
      // ツリー選択時、選択中の不変ID情報を初期化
      this.selectImmutableId = null;
      // 計測データIDとECU名をキャッシュに格納
      this.cacheActiveDataId({ measuredId: this.measuredId, ecuName: systems });
      this.treeChange(arg);
      // 計測データ一覧を表示
      this.createSaveDataList(
        arg.data.projectId,
        arg.data.measuredId,
        systems,
        itemName,
        obdDataId,
        obdSystems,
        arg.data.function_name,
        arg.data.isSpecial
      );
    },

    /**
     * 押下したツリーをActiveにする
     * @param {Object} selectTreeData 選択されているツリーデータ
     */
    /* eslint-disable */
    // 関数内のif文増加によるeslintエラーの抑制 リファクタリングについては非対応
    async treeChange(selectTreeData) {
      const selectFunctionName = selectTreeData.data.function_name;
      let changeFunctionKey = '';

      // 選択している機能名をアクティブkeyと同じ値にする
      if (selectFunctionName === 'alldtc') changeFunctionKey = 'allDtc';
      if (selectFunctionName === 'individualDtc') changeFunctionKey = 'diagCode';
      if (selectFunctionName === 'readinessCode') changeFunctionKey = 'readiness';
      if (selectFunctionName === 'controlHistory') changeFunctionKey = 'controlHistory';
      if (selectFunctionName === 'cst') changeFunctionKey = 'customize';
      if (selectFunctionName === 'cancelCode') changeFunctionKey = 'cancelCode';
      if (selectFunctionName === 'workSupport') changeFunctionKey = 'workSupport';
      if (selectFunctionName === 'dm') changeFunctionKey = 'dataMonitor';
      if (selectFunctionName === 'at') changeFunctionKey = 'activeTest';
      if (selectFunctionName === 'all_dtc') changeFunctionKey = 'obdAllDtc';
      if (selectFunctionName === 'individual_dtc') changeFunctionKey = 'obdDiagCode';
      if (selectFunctionName === 'p_dtc') changeFunctionKey = 'obdPermanentDiagCode';
      if (selectFunctionName === 'obd_vehicle_info') changeFunctionKey = 'obdVehicleInfo';
      if (selectFunctionName === 'onboard_monitor_test') changeFunctionKey = 'obdOnBoardMonitorTest';
      if (selectFunctionName === 'data_monitor') changeFunctionKey = 'obdDataMonitor';
      if (selectFunctionName === 'multiple_dm') changeFunctionKey = 'multipleDataMonitor';
      if (selectFunctionName === 'all_cst') changeFunctionKey = 'allCustomize';
      if (selectFunctionName === 'individual_iumpr') changeFunctionKey = 'obdIumpr';
      if (selectFunctionName === 'individual_readiness') changeFunctionKey = 'obdReadinessStatus';

      // ツリーのドロップダウンメニューが開いているか閉じてるか設定する
      Object.keys(this.isActive).forEach(key => {
        if (changeFunctionKey === key) {
          this.isActive[key] = true;
        } else {
          this.isActive[key] = false;
        }
      });
      // ナビゲーションタブにラベルを設定
      this.navItemLabel = this.setNavItem(changeFunctionKey);
      // OBD機能の場合機能名の後ろに専用ラベルを設定
      if (changeFunctionKey.substring(0, 3) === "obd") {
        this.obdFuncItemLabel = "fixed_resource.obd_menu";
      } else {
        this.obdFuncItemLabel = "";
      }
    },
    /* eslint-able */

    /**
     * ナビゲーションタブを設定する
     * @param {String} 選択しているナビゲーションキー
     * @returns ナビゲーションタブのメッセージを返却
     */
    setNavItem(selectNavKey) {
      let retNavName = "";
      this.isActive[selectNavKey] = true;
      switch (selectNavKey) {
        case "allDtc":
          retNavName = "message.label_measured_data_details_all_dtc";
          break;
        case "diagCode":
          retNavName = "individual.individual_diagnosis_function_diag_code";
          break;
        case "readiness":
          retNavName = "individual.label_readiness_code";
          break;
        case "controlHistory":
          retNavName = "individual.individual_diagnosis_function_vehicle_control_history";
          break;
        case "customize":
          retNavName = "individual.individual_diagnosis_function_customize";
          break;
        case "cancelCode":
          retNavName = "individual.individual_diagnosis_function_cancel_code";
          break;
        case "workSupport":
          retNavName = "individual.individual_diagnosis_function_work_support";
          break;
        case "dataMonitor":
          retNavName = "individual.individual_diagnosis_function_data_monitor";
          break;
        case "activeTest":
          retNavName = "individual.individual_diagnosis_function_active_test";
          break;
        case "obdAllDtc":
          retNavName = "fixed_resource.obd_menu_alldtc";
          break;
        case "obdDiagCode":
          retNavName = "fixed_resource.obd_menu_dtc";
          break;
        case "obdPermanentDiagCode":
          retNavName = "fixed_resource.obd_menu_pdtc";
          break;
        case "obdVehicleInfo":
          retNavName = "fixed_resource.obd_menu_infotype";
          break;
        case "obdOnBoardMonitorTest":
          retNavName = "fixed_resource.obd_menu_monitortest";
          break;
        case "obdDataMonitor":
          retNavName = "fixed_resource.obd_menu_datamonitor";
          break;
        case "multipleDataMonitor":
          retNavName = "message.label_menu_multi_data_monitor";
          break;
        case "allCustomize":
          retNavName = "message.label_menu_all_customize";
          break;
        case "obdIumpr":
          retNavName = "fixed_resource.obd_menu_jumpr";
          break;
        case "obdReadinessStatus":
          retNavName = "fixed_resource.obd_menu_readiness_status";
          break;
      }
      return retNavName;
    },

    // ツリービューの表示・非表示を切り替え
    switchTreeDisplay() {
      this.isTreeViewOpen = !this.isTreeViewOpen;
    },

    // プロジェクト情報編集ダイアログを表示
    async openMemoModal() {
      this.modalMemo = true;
    },

    // プロジェクト情報をクリア
    clearMemo: function () {
      this.$refs.project_memo.clear();
    },

    // プロジェクト情報を保存
    async saveMemo() {
      const latest = await this.$refs.project_memo.save();
      if (latest) {
        // ツリー表示名(計測データ名)変更
        await this.changeTreeName(latest);
        // プロジェクト詳細画面に戻ったときの表示内容を最新化するためキャッシュの内容を更新
        const measuredId = this.measuredId;
        const newMeasures = this.cachedDetails.measures.map(e => {
          Object.keys(e).find(key => {
            e[key].map(data => {
              if (data.registered_at === Number(measuredId)) {
                data.name = latest.dataName;
                data.note = latest.memo;
              }
            });
          });
          return { ...e };
        });
        const newInformation = JSON.parse(JSON.stringify(this.cachedDetails.information));
        newInformation.comment = latest.comment;
        this.cacheProjectDetails({ information: newInformation, measures: newMeasures });
        // プロジェクト一覧画面に戻ったときの表示内容を最新化するためキャッシュの内容を更新
        const newProjectList = this.cachedBuff.list.map(e => {
          const isNeedUpdate = e.id === this.cachedDetails.information.id;
          return { ...e, comment: isNeedUpdate ? latest.comment : e.comment };
        });
        this.cacheDiagProjectList({ ...this.cachedBuff, list: newProjectList });
      }
    },

    closeNoteModal() {
      this.modalMemo = false;
    },

    /**
     * ツリーの表示名変更
     * ALL DTCの場合とALLDTC以外の場合でツリーの階層が異なる
     * @param {Object} latest
     */
    changeTreeName(latest) {
      const treeData = this.treeData.children[0].children;
      // ツリー階層深いため、for文でループして一番深い場所にあるデータ名を変更
      for (const child in treeData) {
        for (const grandChild in treeData[child].children) {
          if (this.isActive['allDtc'] || this.isActive['obdAllDtc']) {
            const isSelected = treeData[child].children[grandChild].isSelected;
            treeData[child].children[grandChild].name = isSelected ? latest.dataName : treeData[child].children[grandChild].name;
          } else {
            for (const data in treeData[child].children[grandChild].children) {
              // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
              /* eslint-disable max-depth */
              if (treeData[child].children[grandChild].children[data].measuredId === this.measuredId) {
                const isSelected = treeData[child].children[grandChild].children[data].isSelected;
                treeData[child].children[grandChild].children[data].name = isSelected ? latest.dataName : treeData[child].children[grandChild].children[data].name;
              } else {
                for (const wsData in treeData[child].children[grandChild].children[data].children) {
                  if (treeData[child].children[grandChild].children[data].children[wsData].measuredId === this.measuredId) {
                    const isSelected = treeData[child].children[grandChild].children[data].children[wsData].isSelected;
                    treeData[child].children[grandChild].children[data].children[wsData].name = isSelected ? latest.dataName : treeData[child].children[grandChild].children[data].children[wsData].name;
                  }
                }
              }
            }
          }
        }
      }
    },

    /**
     * FFD 一覧を表示
     * @param {Object} arg 選択されたデータ
     * @returns FFDモーダル表示
     */
    openFFDModal: async function (arg) {
      if (!arg) return;
      this.isReq05 = this.selectImmutableId === 5000501 || this.selectImmutableId === 6000501;
      // タイトルの設定
      this.ffdSystem = this.isReq05 ? this.$t(this.ecuName) : this.$t(arg.name);
      this.ffdDescription = this.$t(arg.description);
      this.storedDataNumber = arg.stored_data_number ? arg.stored_data_number : '-';
      const status = arg.status ? ` (${this.$t(arg.status)}) ` : '';
      this.ffdTitle = arg.dtc + status;
      const cache = this.cachedFFDs.filter(e => e.system === arg.systemID && e.dtc === arg.dtc && e.measuredId === this.measuredId);
      if (cache.length > 0) {
        // キャッシュ有りならキャッシュ済みデータを表示
        this.ffdTable = cache[0].data;
        this.selectedSystem = arg;
        this.modalFfd = true;
      } else {
        try {
          const endPoint = '/diagDtc/' + this.projectId + '/' + this.measuredId + '/ffd/' + arg.systemID + '/' + arg.dtc;
          const params = { region_info: this.cachedProjectDataSource };
          // キャッシュなしなら FFD 一覧情報を取得
          this.processing = true;
          const res = await api.getParamCall(config.DIAG, endPoint, params, this.operationScreen);
          handler.validate(handler.validateTypes.all, res, this, null, () => {
            // 共通 FFD テーブルコンポーネント向けに情報をセット
            this.ffdTable = res.data.data;
            this.selectedSystem = arg;
            // 同一 FFD の次回表示を高速化させるためキャッシュ
            this.cacheFFDStores([...this.cachedFFDs, { system: arg.systemID, dtc: arg.dtc, data: res.data.data, measuredId: this.measuredId }]);
            // FFD テーブルを表示
            this.modalFfd = true;
          }, (result) => {
            if (result.behaviorType === handler.behaviorTypes.logout) this.logout(this);
          });
        } finally {
          this.processing = false;
        }
      }
    },

    /**
     * BMD一覧表示
     * @param {Object} arg 選択されたデータ
     */
    openBMDModal: async function (arg) {
      if (!arg) return;
      // タイトルの設定
      this.bmdTitle = arg.bmc;
      this.bmdSystem = this.$t(arg.name);
      this.bmdDescription = this.$t(arg.description);

      const cache = this.cachedBMDs.filter(e => e.system === arg.systemID && e.bmc === arg.bmc && e.measuredId === this.measuredId);
      if (cache.length > 0) {
        // キャッシュ有りなら キャッシュ済みデータを表示
        this.bmdTable = cache[0].data;
        this.selectedSystem = arg;
        this.modalBmd = true;
      } else {
        try {
          const params = { region_info: this.cachedProjectDataSource };
          const endPoint = '/vehicleControlHistories/' + this.projectId + '/' + this.measuredId + '/bmd/systems/' + arg.name.replace(DIAG_SYSTEM, "") + '/codes/' + arg.originalBmc;
          this.processing = true;
          const res = await api.getParamCall(config.VCH, endPoint, params, this.operationScreen);
          handler.validate(handler.validateTypes.all, res, this, null, () => {
            // 共通 BMD テーブルコンポーネント向けに情報をセット
            this.bmdTable = res.data.data;
            this.selectedSystem = arg;
            // 同一 BMD の次回表示を高速化させるためキャッシュ
            this.cacheBmdStores([...this.cachedBMDs, { system: arg.systemID, bmc: arg.bmc, data: res.data.data, measuredId: this.measuredId }]);
            // BMD テーブルを表示
            this.modalBmd = true;
          }, (result) => {
            if (result.behaviorType === handler.behaviorTypes.logout) this.logout(this);
          }
          );
        } finally {
          this.processing = false;
        }
      }
    },

    /**
     * 詳細FD一覧表示
     * @param {Object} arg 選択されたデータ
     */
    openDetailFDModal: async function (arg) {
      if (!arg) return;
      // タイトルの設定
      this.fdTitle = this.$t('message.common_title_infomation');
      this.status = arg.status;

      const cache = this.cachedDetailFDs.filter(e => e.measuredId === this.measuredId && e.uniqueStatus === arg.unique_status);
      if (cache.length > 0) {
        // キャッシュ有りなら キャッシュ済みデータを表示
        this.detailFdTable = cache[0].data;
        this.modalDetailFd = true;
      } else {
        try {
          const endPoint = '/workSupports/' + this.projectId + '/' + this.measuredId + '/details/systems/' + this.ecuName.replace(DIAG_SYSTEM, "") + '/options/' + arg.unique_status;
          const params = { region_info: this.cachedProjectDataSource };
          this.processing = true;
          const res = await api.getParamCall(config.WSP, endPoint, params);
          handler.validate(handler.validateTypes.all, res, this, null, () => {
            // 共通 詳細FD テーブルコンポーネント向けに情報をセット
            this.detailFdTable = res.data.data.detail_fd_list;
            // 同一 詳細FD の次回表示を高速化させるためキャッシュ
            this.cacheDetailFdStores([...this.cachedDetailFDs, { system: this.ecuName.replace(DIAG_SYSTEM, ""), measuredId: this.measuredId, status: arg.status, uniqueStatus: arg.unique_status, data: res.data.data.detail_fd_list }]);
            // 詳細FD テーブルを表示
            this.modalDetailFd = true;
          }, (result) => {
            if (result.behaviorType === handler.behaviorTypes.logout) this.logout(this);
          }
          );
        } finally {
          this.processing = false;
        }
      }
    },

    /** 戻るボタン押下イベント */
    backToDetails: function () {
      this.treeData = {};
      this.cacheFFDStores([]);
      this.cacheBmdStores([]);
      this.cacheDetailFdStores([]);
      this.$router.push({
        name: 'diagProjectDetails',
        params: { isActiveLabel: JSON.stringify(this.isActive) }
      });
    },

    /**
     * エクスポートの進捗状況を更新
     * @param {number} percentage 進捗率
     */
    updatePercentage: function (percentage) {
      this.$emit('updateExportPercentage', percentage);
    },

    /**
     * 一覧ヘッダーの値設定
     * @param {String} arg 選択行
     * @returns 存在する場合：値を設定
     *          存在しない場合：-表示
     */
    mkHeaderValue: function (arg) {
      return util.mkHeaderValue(arg);
    },

    /**
     * CSVエクスポート機能
     * @param {Obj} measuredDataColumns 一覧カラム
     * @param {Obj} measuredDataItems 一覧データ
     * @param {Obj} recollectedData 一覧ヘッダデータ
     * @param {boolean} isColumnTranslated カラムについて翻訳済みかどうか
     * @param {boolean} isObd OBDシステムのデータ再生で呼び出しているかどうか
     * @param {string} immutableId 不変ID
     */
    async csvExport(measuredDataColumns, measuredDataItems, recollectedData, isColumnTranslated, isObd = false, immutableId = null) {
      let header = "";
      let body = "";
      let igOnCntVar = "";
      let igOnTimeVar = "";
      let igCntVar = "";
      let absoTimeVar = "";
      if (this.isActive['allDtc']) {
        igOnCntVar = util.mkHeaderValue(recollectedData.cgw_igon_time);
        igOnTimeVar = util.mkHeaderValue(recollectedData.cgw_igon_mill_sec);
      } else {
        igOnCntVar = this.mkHeaderValue(recollectedData.current_igon_time);
        igOnTimeVar = this.mkHeaderValue(recollectedData.current_igon_mill_sec);
        igCntVar = this.mkHeaderValue(recollectedData.current_igon_time);
        absoTimeVar = this.mkHeaderValue(util.convertLocalDateTime(recollectedData.current_absolute_time));
      }
      const igOnCnt = this.$t('message.header_vehicle_dtc_table_igon_counts');
      const igOnCounterValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igOnCntVar;
      const igOnTime = this.$t('message.header_vehicle_dtc_table_igon_times');
      const igOnTimeValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igOnTimeVar;
      const igCnt = this.$t('message.header_vehicle_dtc_table_igcounter');
      const igCounterValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igCntVar;
      const absoTime = this.$t('individual.label_cnc_absolute_time');
      const absoTimeValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + absoTimeVar;
      const counterType = this.$t('message.header_vehicle_dtc_table_type');

      const nameData = measuredDataColumns.map(item => item['name']);
      const vinForCsv = util.escapeForCsv(this.cachedDetails.information.vin);
      const vinHeader = `"${this.$t('message.label_measured_data_search_vin')}",${vinForCsv}\n`;
      const headerLabelList = measuredDataColumns.map(item => {
        if (item['name'] === 'igonCount') return isObd ? `"${igOnCnt}"` : `"${igOnCnt} ${igOnCounterValue}"`;
        if (item['name'] === 'igonTime') return isObd ? `"${igOnTime}"` : `"${igOnTime} ${igOnTimeValue}"`;
        if (item['name'] === 'igCounter') return isObd ? `"${igCnt}"` : `"${igCnt} ${igCounterValue}"`;
        if (item['name'] === 'absoluteTime') return isObd ? `"${absoTime}"` : `"${absoTime} ${absoTimeValue}"`;
        if (item['name'] === 'counterType') return `"${counterType}"`;
        return isColumnTranslated ? `"${item['label']}"` : `"${this.$t(item['label'])}"`;
      });

      headerLabelList.unshift(vinHeader);
      header = headerLabelList.map(head => head).join(",") + "\r\n";
      header = header.replace("\n,", "\n");
      body = measuredDataItems.map((d) => {
        return nameData.map((key) => {
          let retVal = d[key] || typeof d[key] === 'number' ? d[key] : '';
          // キャンセルコードのみmeasureDataItemsの中に言語変更されたデータが入っている為分岐が必要
          if (this.isActive["cancelCode"]) {
            // 種別(counterType)は画面によって文言キー、翻訳済み言語が混在するので、$teで判別してwarnを回避する
            if (key === 'counterType' && this.$te(d[key])) retVal = `${this.$t(d[key])}`;
            if (key === 'ffd') retVal = d['buttonVisible'] ? this.$t('message.available_' + `${key}`) : this.$t('message.no_' + `${key}`);
          } else if (this.isActive["workSupport"]) { // 作業サポートのkeyが他機能と被らないよう分岐を作る
            if (key === 'fd') retVal = d['buttonVisible'] ? this.$t('message.available_' + `${key}`) : this.$t('message.no_' + `${key}`);
            if (key === 'ffd') retVal = d['buttonVisible'] ? this.$t('message.available_' + `${key}`) : d['ffd_status_name'] ? this.$t(d['ffd_status_name']) : this.$t('message.no_' + `${key}`);
            // REQ-05の説明(description)はソートの為にキーのままなので、文言変換を行う
            if (key === 'description' && (immutableId === 5000501 || immutableId === 6000501)) retVal = `${this.$t(d[key])}`;
          } else {
            retVal = this.translateGeneralCsvData(d, key, retVal);
          }
          // 最終的な値が空の場合、ダブルクォーテーションを表示させないように、エスケープ処理を行わないようにする
          return retVal || typeof retVal === 'number' ? util.escapeForCsv(retVal.toString()) : '';
        }).join(",");
      }).join("\r\n") + '\r\n';

      const data = header + body;
      const bomFormatData = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM
      const blob = new Blob([bomFormatData, data], { type: 'text/csv;charset=utf-8' });
      const link = window.document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      // CSVファイル名取得
      let fileName = '';
      if (this.isActive.workSupport && ![13901, 5000501, 6000501].includes(immutableId)) {
        // 作業サポートかつWS.139またはREQ-05以外は機能名をファイル名とする
        // NOTE：「ファイル出力」の要件を参照している機能
        fileName = ('{0}.csv').format(this.getTitle);
      } else {
        let funcName = this.getTitle;
        if ([5000501, 6000501].includes(immutableId)) {
          // REQ-05の場合、機能名を「DTC」とする
          funcName = this.$t('individual.individual_diagnosis_function_diag_code');
        }
        fileName = getCsvFileName(funcName, this.selectedDataName, this.cachedDetails.information.vin);
      }
      link.download = fileName;
      link.style.display = 'none';
      link.click();
      link.remove();
    },

    /**
     * CSVデータ翻訳機能（キャンセルコードと作業サポート以外）
     * @param {Obj} item 一覧の各データ
     * @param {String} name 一覧の各カラム
     * @param {String} value 表示データ
     */
    translateGeneralCsvData(item, columnName, value) {
      let retVal = value;
      if (HEADER_COLUMN_CSV.includes(columnName)) retVal = this.$te(item[columnName]) ? `${this.$t(item[columnName])}` : item[columnName];

      if (columnName === 'name') {
        // OBDでは、システム名の翻訳は必要としていない。また、$teで成功したにもかかわらず$tで翻訳失敗するケースがあるため、UDS側と処理を分ける。
        if (this.isActive['obdAllDtc']) {
          retVal = item[columnName];
        } else {
          retVal = this.$te(item[columnName]) ? `${this.$t(item[columnName])}` : item[columnName];
        }
      }
      if (columnName === 'result') retVal = this.$te(item[columnName]) ? `${this.$t(item[columnName])}` : item[columnName];
      // 種別(counterType)は画面によって文言キー、翻訳済み言語が混在するので、$teで判別してwarnを回避する
      if (columnName === 'counterType' && this.$te(item[columnName])) retVal = `${this.$t(item[columnName])}`;
      if (columnName === 'ffd' || columnName === 'bmd') {
        retVal = item['buttonVisible'] ? this.$t('message.available_' + `${columnName}`) : this.$t('message.no_' + `${columnName}`);
      }
      if (columnName === 'readinessGroup') {
        retVal = this.$t(item[columnName])
      }

      return retVal;
    },

    /**
     * 戻るボタン表示有無確認
     */
    updateShouldShowBackButton() {
      // $refs.work_support の存在を最初にチェックして変数に格納
      const isWs45Available = this.isActive['workSupport'] && this.$refs.work_support ? this.$refs.work_support.isWs45 : false;
      this.shouldShowBackButton = !this.isActive.dataMonitor &&
        !this.isActive.activeTest &&
        !this.isActive.obdDataMonitor &&
        !this.isActive.multipleDataMonitor &&
        !isWs45Available &&
        !this.isActive.cancelCode &&
        !(this.isActive.workSupport && this.selectImmutableId === 14601);
    },

    // ========================== デバッグ環境で動作を行う =============================
    /* Start テスト用の関数一覧 */
    /**
     * DTCのテストデータ出力関数.
     * @param {Array} recollectedData 計測データ
     */
    dtcTestDataExport(recollectedData) {
      // テストdataを生成する
      const test = { info: [] };
      recollectedData.data.forEach(element => {
        // DTCコードが設定されているもののみテスト用で出力する。
        if (element.code) {
          const resourceId = this.removeResourceKey(resource.getDtcDescriptionResource(element, this));
          const testData = {
            system: element.system,
            reference: element.reference,
            code: element.code,
            unspecified_code: element.unspecified_code,
            resource_id: resourceId
          };
          test.info.push(testData);
        }
      });
      if (test.info.length > 0) {
        const systemName = test.info[0].system;
        const blob = new Blob([JSON.stringify(test, null, '  ')], { type: 'application/json' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = ('{0}_DTC_FRONT.json').format(systemName); // 出力するファイルの名前
        link.click();
        link.remove();
      }
    },

    // DIDのテストデータ出力関数
    didTestDataExport() {
      let ffdOrBmd = null;
      let test = null;
      if (this.isActive["controlHistory"]) {
        ffdOrBmd = this.$refs.bmd_modal.getTestData();
        test = this.createBMDTestData(this.bmdTable, ffdOrBmd.items);
      } else if (this.isActive["cancelCode"]) {
        ffdOrBmd = this.$refs.cancel_code.$refs.ffd_modal.getTestData();
        test = this.createFFDTestData(this.$refs.cancel_code.ffdTableItems, ffdOrBmd.items);
        // selectedSystemの変数がキャンセルコードの場合に存在しないため、refsでDIAG_SYSTEMとsystemIdを結合して値を設定する
        this.selectedSystem = { name: DIAG_SYSTEM + this.$refs.cancel_code.systemId };
      } else {
        ffdOrBmd = this.$refs.ffd_modal.getTestData();
        test = this.createFFDTestData(this.ffdTable, ffdOrBmd.items);
      }
      // テストdataを生成する
      // 独自のsortIDでソート
      test.info.sort((a, b) => {
        if (a.sortId < b.sortId) return -1;
        if (a.sortId > b.sortId) return 1;
        return 0;
      });
      // データモニター表示順でソート
      test.info.sort((a, b) => {
        if (a.monitor_order < b.monitor_order) return -1;
        if (a.monitor_order > b.monitor_order) return 1;
        return 0;
      });
      // 独自のsortID削除
      test.info.forEach(element => { delete element.sortId; });

      if (test.info.length > 0) {
        const systemName = this.removeResourceKey(this.selectedSystem.name);
        const csvArray = [[], [], []];
        ffdOrBmd.items.forEach(data => {
          csvArray[0].push(this.$t(data.item));
          csvArray[1].push(this.$t(data.unit));
          csvArray[2].push(data[0]);
        });

        let csvData = '';
        csvArray.forEach(a => {
          const row = a.join(',');
          csvData += row + '\r\n';
        });
        const bomFormatData = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM
        const csvBlob = new Blob([bomFormatData, csvData], { type: 'text/csv;charset=utf-8' });
        const csvLink = document.createElement('a');
        csvLink.href = URL.createObjectURL(csvBlob);
        csvLink.download = ('{0}_DID_FRONT.csv').format(systemName); // 出力するファイルの名前
        csvLink.click();
        csvLink.remove();

        const blob = new Blob([JSON.stringify(test, null, '  ')], { type: 'application/json' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = ('{0}_DID_FRONT.json').format(systemName); // 出力するファイルの名前
        link.click();
        link.remove();
      }
    },

    /**
     * 子コンポーネントのCSVエクスポートのステータスを取得する
     */
    checkCsvExport() {
      if (this.isActive['dataMonitor'] || this.isActive['activeTest']) {
        return this.$refs.data_monitor.ableToExport
      } else if (this.isActive['multipleDataMonitor']) {
        return this.$refs.multiple_data_monitor.ableToExport
      } else if (this.isActive['obdDataMonitor']) {
        return this.$refs.obd_data_monitor.ableToExport
      }
    },

    /**
     * 子コンポーネントのCSVエクスポートを実行する
     * @param {string} _ activeLabelが渡されるが、使用しないためアンダースコアで受け取る
     * @param {object} csvWriter CSV書き込み用のオブジェクト
     */
    async executeCsvExport(_, csvWriter) {
      if (this.isActive['dataMonitor'] || this.isActive['activeTest']) {
        await this.$refs.data_monitor.csvExport(csvWriter)
      } else if (this.isActive['multipleDataMonitor']) {
        await this.$refs.multiple_data_monitor.csvExport(csvWriter)
      } else if (this.isActive['obdDataMonitor']) {
        await this.$refs.obd_data_monitor.csvExport(csvWriter)
      }
    },

    /**
     * FFDのテストデータ出力関数.
     * @param {Array} originalData オリジナルデータ
     * @param {Array} tableData テーブルデータ
     * @returns テストデータ
     */
    createFFDTestData(originalData, tableData) {
      const result = { info: [] };

      // 取得したデータを ffd_save_order で振り分ける
      const groupBySystem = util.groupBy(originalData, 'ffd_save_order');
      // 優先して最新(確定)のデータのみ取得する。
      let currentData = null;
      if (util.isKeyExists(groupBySystem, '0')) {
        currentData = groupBySystem['0'];
      } else {
        currentData = groupBySystem['1'];
      }

      if (currentData) {
        tableData.forEach(element => {
          const keyId = this.removeResourceKey(element.item);
          const index = currentData.findIndex(item => item.id === keyId);
          if (index === -1) {
            logWrapper.log('Current data has no key ID.', keyId);
          }
          else {
            let keyIndex = 0;
            // 10個のキー名までチェックする。
            for (let index = 0; index < 10; index++) {
              keyIndex = String(index);
              if (util.isKeyExists(element, keyIndex)) {
                // keyが存在した場合は処理終了
                break;
              }
            }
            const valueKey = 'value_' + keyIndex;
            const resourceIdKey = 'resouceId_' + keyIndex;

            // テストデータは検出時のみを取得する。
            const findData = currentData[index];

            let sortId = "";
            const keyUnderSplit = keyId.split('_');
            if (keyUnderSplit.length > 1) {
              const second = keyUnderSplit[1].padStart(2, '0');
              sortId = keyUnderSplit[0] + '_' + second;
            }
            if (keyUnderSplit.length > 2) {
              const covertNumber = Number(keyUnderSplit[2]);
              if (!isNaN(covertNumber)) {
                const therd = keyUnderSplit[2].padStart(covertNumber, '0');
                sortId = sortId + '_' + therd;
              }
            }

            const testData = {
              id: keyId,
              sortId: sortId,
              unit: this.removeResourceKey(element.unit),
              digits_after_decimal: findData.digits_after_decimal,
              data_type: findData.data_type,
              value: String(this.roundValue(element[valueKey])),
              value_resource_id: this.removeResourceKey(element[resourceIdKey]),
              monitor_order: findData.monitor_order
            };
            result.info.push(testData);
          }
        });
      }
      return result;
    },

    // BMDのテストデータ出力関数
    createBMDTestData(originalData, tableData) {
      const result = { info: [] };

      // 取得したデータを bmd_save_order で振り分ける
      const groupBySystem = util.groupBy(originalData, 'bmd_save_order');
      // 優先して最新(確定)のデータのみ取得する。
      let currentData = null;
      if (util.isKeyExists(groupBySystem, '0')) {
        currentData = groupBySystem['0'];
      } else {
        currentData = groupBySystem['1'];
      }

      if (currentData) {
        tableData.forEach(element => {
          const keyId = this.removeResourceKey(element.item);
          const index = currentData.findIndex(item => item.id === keyId);
          if (index === -1) {
            logWrapper.log('ID not found in current data.', keyId);
          }
          else {
            let keyIndex = 0;
            // 10個のキー名までチェックする。
            for (let index = 0; index < 10; index++) {
              keyIndex = String(index);
              if (util.isKeyExists(element, keyIndex)) {
                // keyが存在した場合は処理終了
                break;
              }
            }
            const valueKey = 'value_' + keyIndex;
            const resouceIdKey = 'resouceId_' + keyIndex;

            // テストデータは検出時のみを取得する。
            const findData = currentData[index];

            let sortId = "";
            const keyUnderSplit = keyId.split('_');
            if (keyUnderSplit.length > 1) {
              const second = keyUnderSplit[1].padStart(2, '0');
              sortId = keyUnderSplit[0] + '_' + second;
            }
            if (keyUnderSplit.length > 2) {
              const covertNumber = Number(keyUnderSplit[2]);
              if (!isNaN(covertNumber)) {
                const therd = keyUnderSplit[2].padStart(covertNumber, '0');
                sortId = sortId + '_' + therd;
              }
            }

            const testData = {
              id: keyId,
              sortId: sortId,
              unit: this.removeResourceKey(element.unit),
              digits_after_decimal: findData.digits_after_decimal,
              data_type: findData.data_type,
              value: String(this.roundValue(element[valueKey])),
              value_resouce_id: this.removeResourceKey(element[resouceIdKey]),
              monitor_order: findData.monitor_order
            };
            result.info.push(testData);
          }
        });
      }
      return result;
    },

    /**
     * リソースIDを整形する
     * @param {string} resourceId
     * @returns 削除結果
     */
    removeResourceKey(resourceId) {
      let result = "";
      // 設定されていない場合は""文字列で戻す
      if (!resourceId) {
        return result;
      }
      const resources = resourceId.split('.');
      if (resources.length > 0) {
        result = resources[1];
      }
      return result;
    },

    /**
     * 値を10桁に丸める
     * @param {number} value
     * @returns 結果
     */
    roundValue(value) {
      let result = value;
      if (value) {
        if ((typeof value) === "number") {
          result = value.toFixed(10);
        }
      }
      return result;
    },

    /** BMCのテストデータを出力する */
    bmcTestDataExport(recollectedData) {
      // テストdataを生成する
      const test = { info: [] };
      recollectedData.data.forEach(element => {
        // BMCコードが設定されているもののみテスト用で出力する。
        if (element.code) {
          const resourceId = this.removeResourceKey(resource.getBmcDescriptionResource(element, this));
          const testData = {
            system: element.system,
            code: element.code,
            resource_id: resourceId
          };
          test.info.push(testData);
        }
      });
      if (test.info.length > 0) {
        const systemName = test.info[0].system;
        const blob = new Blob([JSON.stringify(test, null, '  ')], {
          type: 'application/json',
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = ('{0}_BMC_FRONT.json').format(systemName); // 出力するファイルの名前
        link.click();
        link.remove();
      }
    },

    /** 選択中のデータ名を取得
     * @param {Object} ツリーデータ
     * @returns {String} 選択中のデータ名
     */
    getSelectedDataName(treeData) {
      for (const item of treeData) {
        if (item.isSelected) {
          return item.name;
        }
        if (item.children) {
          const result = this.getSelectedDataName(item.children);
          if (result) return result;
        }
      }
      return null;
    },
    /* End テスト用の関数一覧 */
  },

  computed: {
    ...mapState({
      language: state => state.systems.language,
      cachedDetails: state => state.cache.projectDetails,
      cachedFFDs: state => state.cache.ffdStores,
      cachedBMDs: state => state.cache.bmdStores,
      cachedDetailFDs: state => state.cache.detailFdStores,
      cachedDataId: state => state.cache.activeMeasuredDataId,
      cachedBuff: state => state.cache.projectListBuff,
      cachedProjectDataSource: state => state.cache.projectDataSource,
      isMovedVehicleToProject: state => state.cache.isMovedVehicleToProject,
      // 再生画面のタイトル設定用Function
      getTitle() {
        let functionName;
        if (this.obdFuncItemLabel) {
          functionName = `${this.$t(this.navItemLabel)}${this.$t(this.obdFuncItemLabel)}`;
        } else {
          functionName = this.$t(this.navItemLabel);
        }
        return functionName;
      },
    }),
    // 診断系のAPIは複数画面から使用されているため
    // 現在の画面で使用されるAPIが診断/データ再生/個別診断のうちどの機能なのか判別する
    operationScreen() {
      return diagnoseResource.operationFrom(this.$router.currentRoute.value.name);
    },

    /**
     * 表示するシステム名を設定する
     * @returns {string} システム名
     */
    configureDisplayEcuName() {
      // システム名の表示にリソースを使うかを判定する。OBD とマルチデータモニタと全カスタマイズの場合は false となる。
      const useResourceDisplayEcuName = !this.obdDataId && !this.isActive['multipleDataMonitor'] && !this.isActive['allCustomize'] && !this.isActive['diagCode'] && !this.isActive['controlHistory'] && !this.isActive['cancelCode'];
      let _displayEcuName = useResourceDisplayEcuName ? this.$t(this.displayEcuName) : this.displayEcuName;

      if (this.isActive['dataMonitor'] || this.isActive['activeTest']) {
        _displayEcuName = this.isSpecial ? `${this.$t(this.displayEcuName)} ${this.$t('message.label_data_special_feature')}` : this.$t(this.displayEcuName);
      }

      return _displayEcuName;
    },

    /** 選択中のデータ名 
     * @returns {String} 選択中のデータ名
    */
    selectedDataName() {
      if (this.treeData?.children) {
        return this.getSelectedDataName(this.treeData.children);
      }
      return '';
    }
  },

  async beforeMount() {
    const cached = this.cachedDetails.information;
    this.projectId = this.cachedDetails.information.id;
    const useCache = util.isFromSettingsPage(util.getPreviousDisplayName(this.$route));
    this.measuredId = String(useCache ? this.cachedDataId.measuredId : Number(this.measuredIdProp));
    this.ecuName = String(useCache ? this.cachedDataId.ecuName : this.systemName.replace(DIAG_SYSTEM, ""));
    this.isActive = useCache ? this.cachedDataId.isActiveLabel : this.isActive;
    this.obdDataId = useCache ? this.cachedDataId.obdDataId : this.obdDataId;
    this.obdSystems = useCache ? this.cachedDataId.obdSystems : this.obdSystems;
    this.itemName = useCache ? this.cachedDataId.itemName : this.itemName;
    this.cacheActiveDataId({
      measuredId: this.measuredId,
      ecuName: this.ecuName.replace(DIAG_SYSTEM, ""),
      isActiveLabel: this.isActive,
      obdDataId: this.obdDataId,
      obdSystems: this.obdSystems,
      itemName: this.itemName
    });
    this.isDomestic = cached.classification;
    await this.setupTreeView();

    // 初期表示時にFFD詳細画面のキャッシュ削除
    this.cacheFFDStores([]);

    // DTCのテストデータ出力(json形式)を行うExport DTC Dataボタンを表示
    // debug 環境のみ実施有効とする
    if (process.env.VUE_APP_DEBUG_LOG) {
      document.onkeydown = (event) => {
        if (event) {
          // Ctrl+Shift+V key detection
          if (event.shiftKey && event.ctrlKey) {
            if (event.code === "KeyV") {
              this.testModeVisible = true;
              return true;
            }
          }
        }
        return util.checkSSM5ValidCharacters(event);
      };
    }
  },

  beforeUnmount() {
    // password変更画面や単位設定画面から戻ってきたときのために、現在選択中の計測データを記憶しておく
    this.cacheActiveDataId({
      measuredId: this.measuredId,
      ecuName: this.ecuName.replace(DIAG_SYSTEM, ""),
      isActiveLabel: this.isActive,
      obdDataId: this.obdDataId,
      obdSystems: this.obdSystems,
      itemName: this.itemName
    });
    // debug 環境のみ実施有効とする
    if (process.env.VUE_APP_DEBUG_LOG) {
      // onkeydown の再登録
      document.onkeydown = (event) => {
        return util.checkSSM5ValidCharacters(event);
      };
    }
  },

  beforeRouteLeave(to, from, next) {
    if (to.name === 'home' && this.isMovedVehicleToProject) {
      // 実行系⇒プロジェクト画面への遷移済フラグ true 且つ、Start押下の場合、確認ダイアログを表示し、OKボタン押下で何もしない。
      alert.showConfirmation(this, null, this.$t('message.label_confirm_message_not_move_home'), null, null, null, true);
      next(false);
    } else {
      next();
    }
  },
};